import { Component } from "react";
import { AlertTriangle, RefreshCw, ArrowLeft } from "lucide-react";
import api from "../lib/api";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, reported: false };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
    if (this.state.reported) return;
    this.setState({ reported: true });
    try {
      api.post("/frontend-error", {
        message: error?.message || String(error),
        stack: error?.stack || null,
        component_stack: info?.componentStack || null,
        page: window.location.pathname,
        user_agent: navigator.userAgent,
      }).catch(() => {});
    } catch (_) {}
  }

  render() {
    if (this.state.error) {
      const page = window.location.pathname;
      return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
          <div className="max-w-md w-full bg-white rounded-2xl border border-slate-200 shadow-sm p-8 text-center">
            <div className="w-14 h-14 rounded-2xl bg-red-50 mx-auto flex items-center justify-center mb-4">
              <AlertTriangle className="w-7 h-7 text-red-500" />
            </div>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">Something went wrong</h2>
            <p className="text-sm text-slate-500 mb-1">
              {this.state.error?.message || "An unexpected error occurred."}
            </p>
            <p className="text-xs text-slate-400 font-mono mb-6">{page}</p>
            <div className="flex items-center justify-center gap-3">
              <button
                onClick={() => { window.history.back(); }}
                className="inline-flex items-center gap-2 px-4 py-2 border border-slate-200 text-slate-700 text-sm font-medium rounded-lg hover:bg-slate-50 transition-colors"
              >
                <ArrowLeft className="w-4 h-4" />
                Go back
              </button>
              <button
                onClick={() => { this.setState({ error: null, reported: false }); window.location.reload(); }}
                className="inline-flex items-center gap-2 px-4 py-2 bg-blue-900 text-white text-sm font-medium rounded-lg hover:bg-blue-800 transition-colors"
              >
                <RefreshCw className="w-4 h-4" />
                Reload
              </button>
            </div>
            <p className="mt-4 text-[11px] text-slate-300">This error has been reported automatically.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
